import { render, staticRenderFns } from "./BrandPickerDialog.vue?vue&type=template&id=5a287ec6&scoped=true"
import script from "./BrandPickerDialog.vue?vue&type=script&lang=js"
export * from "./BrandPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./BrandPickerDialog.vue?vue&type=style&index=0&id=5a287ec6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a287ec6",
  null
  
)

export default component.exports